// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { trackCaptureEvent } from "@eisinc/App/CoveoConnector/Services/CoveoService";
import { xCoveoState } from "@eisinc/App/CoveoConnector/Store/Reducers";
import { CaptureEventRequest } from "@eisinc/App/CoveoConnector/Types/schema";
import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { chain, ExecuteOnSuccessCallback } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProductByPath";

export const CoveoSendTracking: typeof ExecuteOnSuccessCallback = props => {
    const state = props.getState() as xCoveoState;
    if (state.xCoveo?.trackCoveo && window) {
        const targetProduct = props.apiResult;

        const captureEventParameter: CaptureEventRequest = {
            pageUrl: window.location.href,
            eventName: "detail",
            searchHub: "listing",
            products: [{
                productId: targetProduct.id,
                productName: targetProduct.productTitle,
                price: targetProduct.unitListPrice,
                brand: targetProduct.brand?.name as string,
                variantErpNumber: targetProduct.isVariantParent ? targetProduct.properties?.productErpNumber : undefined,
            }],
        };
        trackCaptureEvent(captureEventParameter);
    }
};

addToEndOfChain(chain, CoveoSendTracking);
